import { render } from "./The404Page.vue?vue&type=template&id=caac2efe&scoped=true"
import script from "./The404Page.vue?vue&type=script&lang=js"
export * from "./The404Page.vue?vue&type=script&lang=js"

import "./The404Page.vue?vue&type=style&index=0&id=caac2efe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rightcom-spa/rightcom-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caac2efe"]])

export default __exports__